<template>
    <div class="container-songs-refine-mobile mb-2">
        <ContainerFilterDrawer
            v-bind="{
                showMobileMenu,
                filters,
                updateFilterCurrentValue,
                toggleMobileMenu,
                setShowMobileMenu,
            }"
        ></ContainerFilterDrawer>
        <div class="flex gap-2">
            <!-- Sort Order -->
            <FormFieldSelect
                class="w-full flex-grow"
                :condensed="false"
                id="sortOrder"
                itemValue="value"
                itemText="text"
                :items="orders"
                field="order"
                :value="order"
                @update="({value}) => updateSortOrder(value)"
            ></FormFieldSelect>
            <!-- Button to show mobile drawer-->
            <button
                class="w-full flex-grow justify-between rounded-md border-0 bg-white ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-sky-600 sm:text-sm sm:leading-6"
                @click="toggleMobileMenu"
            >
                Filters<span v-if="selected?.length"> ({{selected?.length}})</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContainerVideosRefineMobile',
    props: [
        // State
        'selected',
        'orders',
        'order',
        'showMobileMenu',
        'filters',

        // Methods
        'updateSortOrder',
        'toggleMobileMenu',
        'updateFilterCurrentValue',
        'setShowMobileMenu',
    ],
};
</script>
